import { Flex as AntdFlex, type FlexProps as AntdFlexProps } from "antd";

export type FlexProps = AntdFlexProps;
export const Flex = AntdFlex;
